import { useEffect, useState } from 'react'

// Column count per viewport, kept in sync with the grid breakpoints in
// _image_assistant_panel.scss (sm: 640px, md: 960px). JS needs it to place the
// expanded preview at the end of the selected image's row.
const getColumns = () => {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return 4
  }
  if (window.matchMedia('(min-width: 960px)').matches) {
    return 4
  }
  if (window.matchMedia('(min-width: 640px)').matches) {
    return 3
  }
  return 2
}

export default function useGridColumns() {
  const [columns, setColumns] = useState(getColumns)

  useEffect(() => {
    const handleResize = () => setColumns(getColumns())
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return columns
}
